import { Outlet, Link } from 'react-router-dom';

export default function AdminShell() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/60 bg-card/80 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-4 py-4">
          <Link to="/" className="text-sm font-extrabold text-primary">
            ← Volver al sitio
          </Link>
          <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
            MuniBus · Administración
          </span>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
